$(document).ready(function() {
	let freeShipping = 250000;
	$('.progress-bar .end').text("$2,500");

	function totalCart() {
		$.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',
			success: function(cart) {
				console.log(Shopify.formatMoney(cart.total_price, '$ {{amount}}'));

				if(cart.total_price > freeShipping) {
					$('.progress-bar .bar-ammount').text('');
					$('.progress-bar .text').hide();
					$('.progress-bar .text-free').css({ "display": "block"});
					$('.progress-bar .bar .progress').css({"width": "100%"});
				}

				if(cart.total_price < freeShipping) {
					let pending = freeShipping - cart.total_price;
					$('.progress-bar .bar-ammount').text(Shopify.formatMoney(pending, '$ {{amount}}'));
					$('.progress-bar .text').css({ "display": "block"});
					$('.progress-bar .text-free').hide();
					let porcentaje = (cart.total_price / freeShipping) * 100;
					$('.progress-bar .bar .progress').css({"width": porcentaje + "%", "transition": "0.4s all ease"});
				}
	      	}
	    });
	}
	
	setTimeout(function() {
		totalCart();
	}, 800);
	
	$(window).on('load', function() {
		totalCart();
	});

	$('.product-quantity .minus, .product-quantity .plus').click(function() {
		setTimeout(function() {
			totalCart();
		}, 700);
	});

	$(document).on('click', '.product-quantity .minus, .product-quantity .plus', function() {
		debugger;
		setTimeout(function() {
			totalCart();
		}, 700);
	});
});